export default {
  Starterkit: 'Starterkit',
  Dashboards: 'Dashboards',
  Classic: 'Classic ',
  Analytical: 'Analytical ',
  Ecommerce: 'Ecommerce ',
  General: 'General ',
  Apps: 'Apps',
  Chats: 'Chats',
  Calendar: 'Calendar',
  ContactList: 'Contact List',
  ContactGrid: 'Contact Grid',
  Email: 'Email',
  Todo: 'Todo',
  UiElements: 'Ui Elements',
  VuesaxComponents: 'Vuesax Components',
  Alert: 'Alert',
  Avatar: 'Avatar',
  Breadcrumb: 'Breadcrumb',
  Buttons: 'Buttons',
  Cards: 'Cards',
  Chips: 'Chips',
  Collapse: 'Collapse',
  Dialog: 'Dialog',
  Divider: 'Divider',
  Dropdown: 'Dropdown',
  List: 'List',
  Loading: 'Loading',
  Navbar: 'Navbar',
  Notification: 'Notification',
  Numberinput: 'Number input',
  Pagination: 'Pagination',
  Popup: 'Popup',
  Progress: 'Progress',
  Sidebar: 'Sidebar',
  Slider: 'Slider',
  Tabs: 'Tabs',
  Tooltip: 'Tooltip',
  Forms: 'Forms',
  FormElements: 'Form Elements',
  Checkboxes: 'Checkboxes',
  Datepicker: 'Datepicker',
  Input: 'Input',
  Radio: 'Radio',
  Select: 'Select',
  Switch: 'Switch',
  Textarea: 'Textarea',
  Upload: 'Upload',
  FormLayouts: 'Form Layouts',
  FormAction: 'Form Action',
  FormBasic: 'Form Basic',
  FormHorizontal: 'Form Horizontal',
  FormWizard: 'Form Wizard',
  DragnDrop: 'Drag n Drop',
  TableExamples: 'Table Examples',
  Basictable: 'Basic table',
  Editabletable: 'Editable table',
  ExpandDatatable: 'Expand Datatable',
  Filtertable: 'Filter table',
  Miscellaneoustable: 'Miscellaneous table',
  Paginationtable: 'Pagination table',
  Selectedtable: 'Selected table',
  SSTtable: 'SST table',
  Charts: 'Charts',
  ApexCharts: 'ApexCharts',
  ChartJs: 'ChartJs',
  Icons: 'Icons',
  MaterialIcons: 'Material Icons',
  ThemifyIcons: 'Themify Icons',
  ExtraComponents: 'Extra Components',
  Carousel: 'Carousel',
  Widgets: 'Widgets',
  AppWidgets: 'App Widgets',
  DataWidgets: 'Data Widgets',
  lang: `Language`,
  es: `Español`,
  en: `English`,
  spanish: `Español`,
  english: `English`,
  name: `Name`,
  login: `Log In`,
  email: `Email`,
  password: `Password`,
  confirm_password: `Repeat password`,
  access_pin: `Access PIN`,
  confirm_access_pin: `Repeat the PIN`,
  administrator: `Administrator`,
  logout: `Logout`,
  settings: `Settings`,
  active: `Active | Actives`,
  inactive: `Inactive | Inactives`,
  total: `Total`,
  new: `New`,
  search: `Search`,
  city: `City`,
  created: `Created`,
  restaurant: `Restaurant`,
  phone: `Phone`,
  save: `Save`,
  delete: `Delete`,
  edit: `Edit`,
  user: `User | Users`,
  without_email: `Without email`,
  without_phone: `Without phone`,
  has_been_created: `"{who}" has been created`,
  has_been_removed: `"{who}" has been removed`,
  has_been_updated: `"{who}" has been updated`,
  new_user: `New user`,
  edit_user: `Edit user`,
  close: `Close`,
  create: `Create`,
  url: `Url`,
  url_precompro: 'Url Precompro.com',
  url_alternative: 'Url alternative',
  subdomain: `Subdomain`,
  new_restaurant: `New restaurant`,
  suggested: `Suggested`,
  not_reset_pin: `Not reset pin`,
  reset_pin: `Reset pin`,
  not_reset_password: `Not reset password`,
  reset_password: `Reset password`,

  white_label: 'White label',
  published: 'Published',
  information: 'Information',
  short_description: 'Short description',
  description: 'Description',
  location: 'Location',
  address: 'Address',
  headquarter: 'Headquarter',
  keywords: 'Keywords',
  price: 'Price',
  maximun_cost_per_person: 'Max. cost per person',
  cost_type: 'Cost type',
  food: 'Food',
  type: 'Type',
  chef: 'Chef',
  service: 'Service | Services',
  requirements: 'Requirements',
  booking_settings: 'Booking settings',
  book_in_advance: 'Book in advance',
  rotation_time: 'Rotation time',
  update_time: 'Update time',
  cancelation_time: 'Cancelation time',
  people_per_booking: 'People per booking',
  presale_from: 'Presale from',
  presale_cost: 'Presale cost',
  maximum_booking_per_hour: 'Max. reservations per hour',
  hour: 'Hour | Hours',
  opening_hours: 'Opening hours',
  presales_hours: 'Presales hours',
  free_presales_hours: 'Free presales hours',
  distribution: 'Distribution',
  section: 'Section',
  not_items: 'Not items',
  table: 'Table | Tables',
  new_table: 'New table',
  edit_table: 'Edit table',
  merged: 'Merged',
  new_merge: 'New merge',
  file: 'File',
  upload_file: 'Upload file',
  download_file: 'Download file',
  download_template: 'Download template',
  processing: 'Processing ...',
  min: 'Min',
  max: 'Max',
  minimum: 'Minimum',
  maximum: 'Maximum',
  private: 'Private',
  rounded: 'Rounded',
  priority: 'Priority',
  availability: 'Availability',
  customer: 'Customer',
  hello: 'Hello',
  click_to_change_logo: 'Click to change logo',
  click_to_change_image: 'Click to change image',
  you_have_a_new_reservation: 'You have a new reservation',
  your_reservation_at: 'Your reservation at',
  has_been_successful: 'has been successful',
  facebook: 'Facebook',
  twitter: 'Twitter',
  instagram: 'Instagram',
  show_in_precompro: 'Show in Precompro',
  web: 'Web',
  select_a_cost_type: 'Select a cost type',
  costless: 'Costless',
  presales: 'Presales',
  opening: 'Opening',
  show_distribution: 'Show distribution',
  show_list: 'Show list',
  hide_address: 'Hide address',
  disable_vat: 'Disable vat',
  disable_confirmation: 'Disable confirmation',
  disable_analytics: 'Disable analytics',
  toggle_view: 'Toggle view',
  contact_email: 'Contact email',
  event_email: 'Event email',
  precompro_description: 'Description for Precompro.com',
  website: 'Website',
  add_section: 'Add section',
  edit_section: 'Edit section',
  select_a_city: 'Elija una ciudad',
  total_sms_send: 'Messages sent',
  active_sms: 'active SMS',
  recharge_list_sms: 'Information of recharges',
  list_send_sms: 'Information of send sms',
  config_module_sms: 'configuration SMS',
  sms_cost: 'Cost SMS',
  limit_sms: 'Total SMS',
  total_sms_pending: 'SMS availables',
  recharge: 'Recharge',
  recharge_add: 'Add Recharge',
  poll: 'Poll',
  new_poll: 'New poll',
  shared: 'Shared',
  add_question_poll: 'Add question poll',
  enabled_waiting_list: 'Enabled waiting list',
  is_bar: 'Is Bar',
  enabled_identity_document: 'Enabled document identity',
  save_value_consumed: 'Save value consumed',
  anticipation_time_user: 'Anticipation time user',
  is_event_table: 'Table for event',
  errors: {
    request: `Sorry, an error has occurred while trying to process your request.`,
    form: `Form is not valid! Please check the fields.`,
  },
}
